import { defineAsyncComponent } from 'vue';
import { app } from './app';

import CarouselLayout from '../components/carousel-layout/CarouselLayout.vue';

app.component('categories-carousel', CarouselLayout);

const asyncComponents = {
    'v-test-contact': () => import('../components/contact/Contact.vue'),
    'v-checkout-auth': () => import('../components/auth/CheckoutAuth.vue'),
    'v-shipping-methods': () => import('../components/checkout/ShippingMethods.vue'),
    'v-checkout-address-guest': () => import('../components/checkout/AddressGuest.vue'),
    'v-checkout-address-customer': () => import('../components/checkout/AddressCustomer.vue'),
    'v-checkout-summary': () => import('../components/checkout/CheckoutSummary.vue'),
    'v-payment-methods': () => import('../components/checkout/PaymentMethods.vue'),
    'v-login-form': () => import('../components/auth/LoginForm.vue'),
    'v-register-form': () => import('../components/auth/RegisterForm.vue'),
    'v-forgot-password-form': () => import('../components/auth/ForgotPasswordForm.vue'),
    'v-shipping-estimated': () => import('../components/products/ShippingEstimated.vue'),
    'v-header-shipping-announcement': () => import('../components/layouts/HeaderShippingAnnouncement.vue'),

    // Mobile menu drawer & components
    'v-mobile-drawer': () => import('../components/mobile-menu/MobileMenuDrawer.vue'),
    'v-mobile-orders': () => import('../components/mobile-menu/MobileOrders.vue'),
    'v-mobile-category': () => import('../components/mobile-menu/MobileCategory.vue'),
    'v-wishlist-products-mobile': () => import('../components/mobile-menu/WishlistProductsMobile.vue'),
    'v-mobile-search': () => import('../components/mobile-menu/MobileSearch.vue'),
    'v-profile-edit-mobile': () => import('../components/mobile-menu/ProfileEditMobile.vue'),
    'v-profile-password-mobile': () => import('../components/mobile-menu/ProfilePasswordMobile.vue'),
    'v-rma-form': () => import('../components/rma/RmaForm.vue'),
};

Object.entries(asyncComponents).forEach(([name, importer]) => {
    app.component(name, defineAsyncComponent(importer));
});
